<div class="row pt-4">
    <div class="col-md-6 col-xl-3">
        <div class="widget-rounded-circle card bg-purple shadow-none">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <div class="avatar-lg rounded-circle bg-soft-light">
                            <i class="fe-bar-chart-line- font-28 avatar-title text-white"></i>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-end">
                            <h2 class="text-white mt-2"><span data-plugin="counterup">2</span></h2>
                            <p class="text-white mb-0 text-truncate">Proyectos Creados</p>
                        </div>
                    </div>
                </div> <!-- end row-->
            </div>
        </div> <!-- end widget-rounded-circle-->
    </div> <!-- end col-->

    <div class="col-md-6 col-xl-3">
        <div class="widget-rounded-circle card bg-info shadow-none">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <div class="avatar-lg rounded-circle bg-soft-light">
                            <i class="fe-users font-28 avatar-title text-white"></i>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-end">
                            <h2 class="text-white mt-2"><span data-plugin="counterup">34</span></h2>
                            <p class="text-white mb-0 text-truncate">Metas cumplidas</p>
                        </div>
                    </div>
                </div> <!-- end row-->
            </div>
        </div> <!-- end widget-rounded-circle-->
    </div> <!-- end col-->

    <div class="col-md-6 col-xl-3">
        <div class="widget-rounded-circle card bg-pink shadow-none">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <div class="avatar-lg rounded-circle bg-soft-light">
                            <i class="fe-shuffle font-28 avatar-title text-white"></i>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-end">
                            <h2 class="text-white mt-2"><span data-plugin="counterup">3</span></h2>
                            <p class="text-white mb-0 text-truncate">Objetivos alcanzados</p>
                        </div>
                    </div>
                </div> <!-- end row-->
            </div>
        </div> <!-- end widget-rounded-circle-->
    </div> <!-- end col-->

    <div class="col-md-6 col-xl-3">
        <div class="widget-rounded-circle card bg-success shadow-none">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <div class="avatar-lg rounded-circle bg-soft-light">
                            <i class="fe-download font-28 avatar-title text-white"></i>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-end">
                            <h2 class="text-white mt-2"><span data-plugin="counterup">3</span></h2>
                            <p class="text-white mb-0 text-truncate">Unidades adscritas</p>
                        </div>
                    </div>
                </div> <!-- end row-->
            </div>
        </div> <!-- end widget-rounded-circle-->
    </div> <!-- end col-->
</div>
<!-- end row-->

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="dropdown float-end">
                    <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="mdi mdi-dots-vertical"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                        <!-- item-->
                        <a href="#" class="dropdown-item">Sales Report</a>
                        <!-- item-->
                        <a href="#" class="dropdown-item">Export Report</a>
                        <!-- item-->
                        <a href="#" class="dropdown-item">Profit</a>
                        <!-- item-->
                        <a href="#" class="dropdown-item">Action</a>
                    </div>
                </div>

                <h4 class="header-title mb-3">Product License</h4>
                <div class="position-relative">
                    <div class="row align-items-center">
                        <div class="col-xl-5">
                            <h5>Standard <span class="text-muted fw-normal"> - Single Site</span> <b class="px-2">-</b> <span class="text-muted">30%</span></h5>
                        </div>
                        <div class="col-xl-7">
                            <div class="progress" style="height: 6px;">
                                <div class="progress-bar bg-info" role="progressbar" style="width: 30%;" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mt-2">
                        <div class="col-xl-5">
                            <h5>Multisite <span class="text-muted fw-normal"> - Unlimited sites</span> <b class="px-2">-</b> <span class="text-muted">60%</span></h5>
                        </div>
                        <div class="col-xl-7">
                            <div class="progress" style="height: 6px;">
                                <div class="progress-bar bg-warning" role="progressbar" style="width: 60%;" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mt-2">
                        <div class="col-xl-5">
                            <h5>Extended <span class="text-muted fw-normal"> - For paying users</span> <b class="px-2">-</b> <span class="text-muted">85%</span></h5>
                        </div>
                        <div class="col-xl-7">
                            <div class="progress" style="height: 6px;">
                                <div class="progress-bar bg-danger" role="progressbar" style="width: 85%;" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-5">
                                <div class="apex-charts" id="sparkline-chart-1"></div>
                            </div>
                            <div class="col-6 offset-1">
                                <div class="text-end">
                                    <p class="font-14 mb-1">Total Products Sales</p>
                                    <h2 class="fw-bold mb-1">64.5K</h2>
                                    <h5 class="mb-0 text-success"><i class="mdi mdi-trending-up font-18 me-1"></i>20.7%</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-5">
                                <div class="apex-charts" id="sparkline-chart-2"></div>
                            </div>
                            <div class="col-6 offset-1">
                                <div class="text-end">
                                    <p class="font-14 mb-1">Active Users</p>
                                    <h2 class="fw-bold mb-0">50.24K</h2>
                                    <h5 class="mb-0 text-success"><i class="mdi mdi-trending-up font-18 me-1"></i>20.7%</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end row -->